export default __webpack_public_path__ + "static/media/kitchen3-afterA-1920w.b0ca9015.webp";